import { createContext } from 'react';

const AppStateContext = createContext({
  /**
   * Although it is possible to remove the following I like to keep them here
   * because they help anyone importing AppStateContext to understand what properties/functions
   * this particular context has available
   */

  currentPage: 'home',
  selectedContract: '',
  selectedCustomerId: '',
  contactEmail: '',
  defaultNumber: '',
  callTime: '',
  sharepointLink: '',
  token: '',
  userId: '',
  name: '',
  customerInfoMap: {},
  userPermissionsList: [],
  contractList: {},
  actionCodes: [],
  siteLogo: {},
  contractCriticalCode: {
    1: {
      CriticalCode: "PM1",
      Details: "Critical Risk",
      PriorityCode: 1,
      ResponseTime: 0,
    },
    2: {
      CriticalCode: "PM2",
      Details: "High Risk",
      PriorityCode: 2,
      ResponseTime: 0,
    },
    3: {
      CriticalCode: "PM3",
      Details: "Medium Risk",
      PriorityCode: 3,
      ResponseTime: 0,
    },
    4: {
      CriticalCode: "PM4",
      Details: "Low Risk",
      PriorityCode: 4,
      ResponseTime: 0,
    },
  },
  contractDepartments: {},
  contractCallers: {},
  serviceCentreCode: 0,

  deleteUserRelatedState: () => {},
  setAppPageDetails: pageName => {},
  setAppStateDetails: (appStateDetails: {}) => {},
  setContractCriticalCode : criticalCodes => {},
  setContractCallers: (contracts: []) => {},
  setContractList: (contractList: {}) => {},
  resetContractDetails: () => {},
  updateCustomerInfoMap: (customerInfo: []) => {},
});

export default AppStateContext;
